import * as React from 'react';
import { useKeycloak, ReactKeycloakProvider } from '@react-keycloak/web';
import * as auth from 'auth-provider';
import { client } from 'utils/api-client';
import { useAsync } from '@agri/lib-hooks';

async function bootstrapAppData() {
  /** Fills up localstorage with location information.*/
  const regions = await client('locations', { method: 'GET', data: null, headers: {} });
  localStorage.setItem('regions', JSON.stringify(regions));
}

const AuthContext = React.createContext();
AuthContext.displayName = 'AuthContext';

function AuthProvider(props) {
  const { keycloak, initialized } = useKeycloak();
  const [user, setUser] = React.useState();
  /**Get token from keycloak */
  const token = React.useMemo(() => keycloak.token, [keycloak.token]);

  React.useEffect(() => {
    keycloak.loadUserProfile().then(user => setUser(user));
    bootstrapAppData();
  }, []);
  const logout = React.useCallback(() => {
    keycloak.logout();
    localStorage.clear();
  });

  const value = React.useMemo(() => ({ logout, user, token }), [logout, user, token]);

  return <AuthContext.Provider value={value} {...props}></AuthContext.Provider>;
}
function useAuth() {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error(`useAuth must be used within a AuthProvider`);
  }
  return context;
}

function useClient() {
  const { user, token } = useAuth();
  return React.useCallback((endpoint, config) => client(endpoint, { ...config, token }), [token]);
}

export { AuthProvider, useAuth, useClient };
